import { Component } from '@angular/core';
import { BreadcrumbsComponent } from '../../../ui/admin/breadcrumbs/breadcrumbs.component';
import { SetupWizardEditor } from '../../../ui/admin/setup-wizard/setup-wizard-editor/setup-wizard-editor';

@Component({
	selector: 'app-setup-wizard',
	imports: [BreadcrumbsComponent, SetupWizardEditor],
	standalone: true,
	templateUrl: './setup-wizard.html',
	styleUrl: './setup-wizard.scss',
})
export class SetupWizard {}
